import { hhmmss } from '../../../util/date-time';

export function realtimeMarketsTimeSeriesTransform(data, params, map) {
    if (data && data.Data) {
        return data.Data.map(item => {
            return {
                security: map.get(item.Ticker),
                frequency: params.frequency,
                openTime: hhmmss(item.OpenMinutes * 60),
                closeTime: hhmmss(item.CloseMinutes * 60),
                preOpenTime: hhmmss(item.PreMinutes * 60),
                postCloseTime: hhmmss(item.AfterMinutes * 60),
                data: formatData(item.DailyData, [])
            };
        });
    } else {
        return [];
    }
}

/**
 * @param {Object} data - data which come from markets chart data
 * @param {Array} arry - a new empty array to store transform data
 */
const formatData = (data, arry) => {
    const dataArray = data.LastPrice || data.SubDataPoints;
    dataArray.forEach(item => {
        if (item.SubDataPoints) {
            arry.push({
                data: item.Date,
                lastPrice: item.Last,
                minutesData: formatData(item, []),
                openPrice: item.Open,
                originalDate: item.OriginalDate || item.Date,
                previousClosePrice: item.PreviousClosePrice
            });
        } else {
            arry.push({
                date: item.Date || item.OriginalDate,
                highPrice: item.High,
                lastPrice: item.Last,
                lowPrice: item.Low,
                openPrice: item.Open,
                originalDate: item.OriginalDate || item.Date,
                originalTime: item.OriginalTime || '00:00',
                time: transformTimesNumToDate(item.Time),
                volume: `${item.Volume}`
            });
        }
    });
    return arry;
};

/**
 * @param {Number} time - make time num to string date
 */
const transformTimesNumToDate = time => {
    if (time < 1) {
        return '00:00:00';
    }
    let leftTime = Math.floor(Math.trunc(time) / 60);
    let middleTime = time % 60;
    leftTime = /^[1-9]$/.test(leftTime) ? `0${leftTime}` : `${leftTime}`;
    middleTime = /^\d$/.test(middleTime) ? `0${middleTime}` : `${middleTime}`;
    const timeArry = `${time}`.match(/\d.([1-9]+)/);
    const rightTime = timeArry ? timeArry[1] : '00';
    return `${leftTime}:${middleTime}:${rightTime}`;
};
